export default __webpack_public_path__ + "static/media/ui_icon_bell.f131a1df.svg";